<template>
  <el-dialog
    title="Authenticator Setup"
    :visible.sync="isShow2FAForm"
    class="medium wallet-dialog"
    :close-on-click-modal="false" @open="onOpen"
    >
    <div class="popup-inner" :class="{ 'loading': isProcessing }">
      <h3 class="display-flex-center text-bold"></h3>
      <div class="item">
        <label>1. Install one of the applications on your mobile</label>
        <ul style="padding-left: 30px;">
          <li>FreeOTP</li>
          <li>Google Authenticator</li>
        </ul>
      </div>
      <div class="item">
        <label>2. Open the authenticator app and scan this qr code</label>
        <div class="item item-qr display-flex-center mt-2">
          <qr-code :size="200" :text="`${faData.uri}`"></qr-code>
        </div>
        <div class="item display-flex-center">
          <el-tag
            type="warning"
            effect="light">
            <i class="el-icon-warning"></i>Notice: Please keep your secret key
          </el-tag>
        </div>
        <div class="item">
          <div class="input-wrap small">
              <el-input :value="faData.secret" disabled></el-input>
              <el-button @click="copy(faData.secret)"><i class="el-icon-copy-document"></i>Copy</el-button>
            </div>
        </div>
      </div>
      <div class="item">
        <label>3. Enter one time code provided by the applications and click Submit to finish the setup</label>
      </div>
      <div class="item">
        <label>One time code (*)</label>
        <el-input value="" v-model="form.code" type="text"></el-input>
      </div>
      <div class="item">
        <button type="button" class="btn" :disabled="!isValidatedForm" @click="submit"><span>Submit</span></button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import Vue from 'vue'
import VueQRCodeComponent from 'vue-qrcode-component'
Vue.component('qr-code', VueQRCodeComponent)
export default {
  components: {
  },
  data () {
    return {
      isProcessing: false,
      isCalculator: false,
      form: {
        code: '',
        secret: ''
      },
      estimateData: {}
    }
  },
  computed: {
    faData () {
      return this.$store.getters.faData
    },
    isValidatedForm () {
      return this.form.code && this.form.secret
    },
    isShow2FAForm: {
      get () {
        return this.$store.getters.isShow2FAForm
      },
      set () {
        this.$store.dispatch('toggle2FAForm')
      }
    }
  },
  methods: {
    copy (text) {
      text = text + ''
      this.$copyText(text).then(e => {
        this.$store.dispatch('showSuccessMsg', this.$t('TEXT_COPIED', 'Copied'))
      })
    },
    onOpen () {
      this.form.secret = this.faData.secret
    },
    submit () {
      if (!this.isValidatedForm) return
      this.isProcessing = true
      this.$store.dispatch('enable2FA', this.form).then(rs => {
        if (rs) {
          this.$store.dispatch('toggle2FAForm')
          this.$store.dispatch('getUser')
        }
      }).finally(() => {
        this.isProcessing = false
      })
    }
  }
}
</script>
